import Regex from "../../utils/regexValidation";
import commonMessage from "../../constants/commonMessage";

const {
  EMAIL_REQUIRED,
  VALID_EMAIL,
  PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  NEW_PASSWORD_REQUIRED,
  VALID_PASSWORD,
  OTP_REQUIRED
} = commonMessage;
const { email_regex, passwordRegex } = Regex;

export const auth = {
  // Login Schema
  loginSchema: {
    email: {
      required: true,
      message: EMAIL_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(email_regex);
      },
      invalidMessage: VALID_EMAIL,
      extraMessage: true,
    },
    password: {
      required: true,
      message: PASSWORD_REQUIRED,
      extraMessage: false,
    },
  },

  //   // Sign Up Schema
  //   signupSchema: {
  //     display_name: {
  //       required: true,
  //       message: "Please provide name.",
  //     },
  //     user_email: {
  //       required: true,
  //       message: "Please provide email.",
  //       validate: (value, inputData = {}) => {
  //         return value.match(email);
  //       },
  //       invalidMessage: "Invalid email.",
  //       extraMessage: true,
  //     },
  //     phone: {
  //       required: true,
  //       message: "Please provide phone number.",
  //       validate: (value, inputData = {}) => {
  //         return value.match(mobileRegex);
  //       },
  //       invalidMessage: "Invalid phone number.",
  //       extraMessage: true,
  //     },
  //     user_pass: {
  //       required: true,
  //       message: "Please provide your password.",
  //       validate: (value, inputData = {}) => {
  //         return value.match(passwordRegex);
  //       },
  //       invalidMessage:
  //         "Password should have at least 8 characters and contain uppercase letters, special characters, and numeric values.",
  //       extraMessage: true,
  //     },
  //     sendUpdates: {
  //       required: false,
  //     },
  //   },

  //   // Forgot Password Schema
  forgotPasswordSchema: {
    email: {
      required: true,
      message: EMAIL_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(email_regex);
      },
      invalidMessage: VALID_EMAIL,
      extraMessage: true,
    },
  },
  verifyPasswordSchema: {
    email: {
      required: true,
      message: EMAIL_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(email_regex);
      },
      invalidMessage: VALID_EMAIL,
      extraMessage: true,
    },
    otp: {
      required: true,
      message: OTP_REQUIRED,
    },
  },
  updatePasswordSchema: {
    password: {
      required: true,
      message: NEW_PASSWORD_REQUIRED, 
      validate: (value, inputData = {}) => {
        return value.match(passwordRegex);
      },
      invalidMessage: VALID_PASSWORD,
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: CONFIRM_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return value === inputData?.password 
          
       },
      invalidMessage: "Password does not match the new password.",
      extraMessage: true,
    },
  },

  resetPasswordSchema: {
    newPassword: {
      required: true,
      message: NEW_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(passwordRegex);
      },
      invalidMessage: VALID_PASSWORD,
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: CONFIRM_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(passwordRegex);
      },
      invalidMessage: VALID_PASSWORD,
      extraMessage: true,
    },
  },

  //   // Question Stepper
  //   questionStepperSchema: {
  //     interest: {
  //       required: true,
  //       message: "",
  //       validate: (value, inputData = {}) => {
  //         return Array.isArray(value) && value.length > 0;
  //       },
  //       invalidMessage: "Please select atleast one.",
  //       extraMessage: true,
  //     },
  //     learning_goal: {
  //       required: true,
  //       message: "",
  //       validate: (value, inputData = {}) => {
  //         return Array.isArray(value) && value.length > 0;
  //       },
  //       invalidMessage: "Please select atleast one.",
  //       extraMessage: true,
  //     },
  //     time_dedication: {
  //       required: true,
  //       message: "Please select time",
  //     },
  //   },

  //   // Change Password Schema
  //   changePasswordSchema: {
  //     phone: {
  //       required: false,
  //     },
  //     newPassword: {
  //       required: true,
  //       message: "Please provide your new password.",
  //       validate: (value, inputData = {}) => {
  //         return value.match(passwordRegex);
  //       },
  //       invalidMessage:
  //         "Password should have at least 8 characters and contain uppercase letters, special characters, and numeric values.",
  //       extraMessage: true,
  //     },
  //     confirmPassword: {
  //       required: true,
  //       message: "Please provide your confirm password.",
  //       validate: (value, inputData) => {
  //         return value === inputData?.newPassword;
  //       },
  //       invalidMessage: "Confirm password does not match the new password.",
  //       extraMessage: true,
  //     },
  //   },
};
